import clsx from "clsx";
import { t } from "i18next";
import { FC, useEffect, useState } from "react";
import { saveMessageMedia } from "src/actions/chat";
import Message from "src/app/models/Message";
import db from "src/db";
import * as Log from "src/util/SDayslogger";
import { InvoicePreviewModal } from "../order-modal";

interface OrderMessageProps {
  message: Message;
  bgChat?: string;
  txChat?: string;
  children?: any;
}

const OrderMessage: FC<OrderMessageProps> = (props) => {
  const [orderData, setOrderData] = useState<any>();
  const [itemList, setItemList] = useState<any>([]);
  const [isOpenInvoice, setIsOpenInvoice] = useState<boolean>(false);
  let { message, bgChat, txChat, children } = props;

  const onClose = () => {
    setIsOpenInvoice(false);
  };

  const saveMedia = () => {
    if (!message.mediaUrl) return alert(t("HC.Error.FailedUpload"));

    let filename = t("HC.File.Untitled");
    if (message.filename && message.filename !== "")
      filename = message.filename;

    return saveMessageMedia(message.mediaUrl, message.filename);
  };

  let mediaFileName = message.filename;
  if (mediaFileName && mediaFileName?.length > 20) {
    mediaFileName = mediaFileName?.substring(0, 20) + "...";
  }

  const getOrderSNByQueryString = (str: string) => {
    const queryParams = str.split("&");
    for (const param of queryParams) {
      if (param.startsWith("id=")) {
        const idValue = param.split("=")[1];
        const decodedId = decodeURIComponent(idValue);
        return decodedId;
      }
    }
    return undefined;
  };

  const getOrderSNByText = (str: string) => {
    const strs = str.split(" ");
    for (const s of strs) {
      if (s.startsWith("INV/")) return s;
    }
    return undefined;
  };

  useEffect(() => {
    let isMounted = true;

    const getOrderData = async () => {
      let mediaUrl = message.mediaUrl;
      const urlParts = mediaUrl?.split("?");
      let orderDatas: any;

      if (message.channel === "tokopedia") {
        const order_sn =
          urlParts && urlParts.length >= 2
            ? getOrderSNByQueryString(urlParts[1])
            : getOrderSNByText(mediaUrl!);
        Log.debug(
          "chat order serial number: ",
          order_sn,
          ",media_url:",
          mediaUrl
        );
        try {
          const querySnapshot = await db
            .collection("orders")
            .where("ordersn", "==", order_sn)
            .get();

          if (isMounted) {
            orderDatas = querySnapshot.docs.map((doc) => doc.data());
          }
        } catch (error) {
          orderDatas = undefined;
          if (isMounted) {
            Log.error("Error fetching order data:", error);
          }
        }
      }

      if (message.channel === "lazada" && message?.order) {
        try {
          const orderRef = db.collection("orders").doc(message.order.id);
          const getOrderById = await orderRef.get();

          if (getOrderById.exists && isMounted) {
            let data_order = getOrderById.data();
            orderDatas = [data_order];
          }
        } catch (error) {
          orderDatas = undefined;
          if (isMounted) {
            Log.error("Error fetching order:", error);
          }
        }
      }

      if (message.channel === "lazada") {
        if (message?.orderSN) {
          const order_sn = message?.orderSN;
          try {
            const querySnapshot = await db
              .collection("orders")
              .where("ordersn", "==", order_sn)
              .get();

            if (isMounted) {
              orderDatas = querySnapshot.docs.map((doc) => doc.data());
            }
          } catch (error) {
            orderDatas = undefined;
            if (isMounted) {
              Log.error("Error fetching order data:", error);
            }
          }
        } else if (message?.order) {
          try {
            const orderRef = db.collection("orders").doc(message.order.id);
            const getOrderById = await orderRef.get();

            if (getOrderById.exists && isMounted) {
              let data_order = getOrderById.data();
              orderDatas = [data_order];
            }
          } catch (error) {
            orderDatas = undefined;
            if (isMounted) {
              Log.error("Error fetching order:", error);
            }
          }
        }
      }

      if (message.channel === "shopee" && message?.order) {
        try {
          const orderRef = db.collection("orders").doc(message.order.id);
          const getOrderById = await orderRef.get();

          if (getOrderById.exists && isMounted) {
            let data_order = getOrderById.data();
            orderDatas = [data_order];
          }
        } catch (error) {
          orderDatas = undefined;
          if (isMounted) {
            Log.error("Error fetching order:", error);
          }
        }
      }

      if (message.channel === "tiktok" && message?.order) {
        try {
          const orderRef = db.collection("orders").doc(message.order.id);
          const getOrderById = await orderRef.get();

          if (getOrderById.exists && isMounted) {
            let data_order = getOrderById.data();
            orderDatas = [data_order];
          }
        } catch (error) {
          orderDatas = undefined;
          if (isMounted) {
            Log.error("Error fetching order:", error);
          }
        }
      }

      if (orderDatas && orderDatas?.length > 0 && isMounted) {
        Log.debug(orderDatas[0], "order for chatmessage found");
        setOrderData(orderDatas[0]);
        setItemList(orderDatas[0]?.itemList);
      }
    };

    getOrderData();

    return () => {
      isMounted = false;
    };
  }, []);

  const capitalizeWords = (str: String) => {
    return str
      .replaceAll("_", " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const formatNumber = (number: number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  let totalAmount = 0;
  orderData?.itemList?.forEach((item: any) => {
    let price: number;
    if (item.discountedPrice) {
      price = item.discountedPrice;
    } else {
      if (item.originalPrice) {
        price = item.originalPrice;
      } else {
        price = item.priceActual;
      }
    }
    totalAmount += price * item.qtyOrderItem;
  });

  return (
    <>
      {!orderData && (
        <div
          className={clsx(
            "product-order-card rounded",
            `${bgChat}`,
            "d-flex flex-row align-items-center bg-opacity-25"
          )}
          title={message.filename}
        >
          <div
            className="bi bi-file-earmark-text fs-3x"
            style={{ color: txChat }}
          ></div>
          <div
            className="container-sm"
            style={{ paddingLeft: "5px", color: txChat }}
          >
            {mediaFileName}
          </div>
          <div
            className="d-flex flex-column justify-content-end"
            style={{ width: "70px" }}
          >
            <div
              className="btn bi bi-download fs-3"
              onClick={saveMedia}
              style={{
                color: txChat,
                paddingTop: "5px",
                paddingLeft: "0px",
                paddingRight: "0px",
                paddingBottom: "0px",
              }}
            ></div>
            <div
              className="text-center"
              style={{ fontSize: "10px", color: txChat }}
            >
              {message.filesize}
            </div>
          </div>
        </div>
      )}

      {orderData && (
        <div
          className={clsx(
            "product-order-card rounded",
            `${bgChat}`,
            "d-flex flex-row align-items-start bg-opacity-25 col-gap-2"
          )}
          style={{
            width: "fit-content",
            cursor: "pointer",
          }}
          title={message.filename}
          onClick={() => {
            setIsOpenInvoice(true);
          }}
        >
          <div className="product-image-container">
            <img
              src={itemList[0]?.imageUrl}
              className="product-image-size"
            />
          </div>
          <div className="product-info-container" style={{ color: "black" }}>
            <div className="product-name" style={{ fontSize: "12px" }}>
              <span style={{ width: "80px", display: "inline-block" }}>
                {t("HandledCustomer.RoomChat.SerialNum")}
              </span>
              : {orderData?.ordersn}
            </div>
            <div className="product-price" style={{ fontSize: "12px", marginTop: "2px" }}>
              <span style={{ width: "80px", display: "inline-block" }}>
                {t("Common.Modal.Column.Header.Status")}
              </span>
              : {orderData && capitalizeWords(orderData.status)}
            </div>
            <div className="product-price" style={{ fontSize: "12px", marginTop: "2px" }}>
              <span style={{ width: "80px", display: "inline-block" }}>
                {t("HandledCustomer.RoomChat.GranTot")}
              </span>
              : Rp {formatNumber(totalAmount)}
            </div>
            <div
              className="fs-9 mb-0 pb-0"
              style={{
                textDecoration: "underline",
                fontSize: "10px",
                marginTop: "4px"
              }}
            >
              {t("HandledCustomer.RoomChat.SeeDetail")}
            </div>
          </div>
        </div>
      )}

      {isOpenInvoice && (
        <InvoicePreviewModal
          open={isOpenInvoice}
          close={onClose}
          marketplaceType={orderData?.marketplaceType}
          downloadInv={saveMedia}
          data={orderData}
        />
      )}
    </>
  );
};

export default OrderMessage;
